import { useSelector } from "react-redux";
import { RootState } from "../../../store/storeConfig";
import storeRTK from "../../../store/storeRTK";
import { setHistoryfilterCallCount } from "../../../actions/call";
import { HistoryContainer } from "../../common/HistoryContainer/HistoryContainer";

const CallHistory = () => {
  const history = useSelector((state: RootState) => state.history);
  const { conversations } = history || {};

  return (
    <HistoryContainer<any>
      data={conversations}
      type="call"
      setCount={(count) => storeRTK.dispatch(setHistoryfilterCallCount(count))}
      emptyTitle="No Call history"
      emptyDescription="Start a new call or wait for the call"
    />
  );
};

export default CallHistory;
